function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdminRoom = function SvgAdminRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20 0c11 0 20 9 20 20s-9 20-20 20S0 31 0 20 9 0 20 0z",
    style: {
      fill: "#8b9c8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6 24.2c-.4.3-.9.3-1.3 0-2.3-2.1-3.9-4.5-4.3-7.7-.1-.5.3-.9.7-1l3.9-1.1h.5l3.9 1.1c.5.1.8.6.7 1-.2 3.2-1.8 5.6-4.1 7.7z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7 10.1h.5l8 2.2c.4.1.7.5.7 1v.1c0 4-.8 7.3-2.3 10-1.5 2.7-3.6 4.7-6.2 6.5-.3.2-.7.2-1 0-2.6-1.7-4.7-3.8-6.2-6.5s-2.3-5.9-2.3-10v-.1c0-.4.3-.8.7-1l8.1-2.2zm.6 2.3h-.5l-6 1.7c-.4.1-.7.5-.7 1 0 5.4 2.7 9 6.4 11.8.4.3.9.3 1.2 0C24.3 24 27 20.4 27 15c0-.4-.3-.8-.7-1l-6-1.6z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#fff"
    }
  }));
};
export default SvgAdminRoom;